import { IAppTheme } from '@msx/platform-services';

export const getStyles = (theme: IAppTheme) => {
    return {
        imageContainerDiv: {
            textAlign: "center",
            // paddingTop: '30px',
            // paddingBottom: '30px',
        },
        imageContainer: {
            maxWidth: "100%",
            maxHeight: "400px",
            height: "auto",
            width: "auto",
            objectFit: "contain" as const,
        },
        subHeadingContainer: {
            //marginTop: 24
            marginBottom: '20px',
        },
        subheading: {
            marginBottom: "0",
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '20px'
        },
        subText: {
            marginBottom: "10px",
            fontWeight: 600,
        },
        description: {
            marginBottom: 0,
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px'
        },
        bulletPoints: {
            marginBottom: 0,
            marginTop: "5px",
            textAlign: "justify",
            position: "relative",
            right: "0.5em",
            "& li": {
                lineHeight: "20px",
                marginBottom: "5px"
            }
        },
        modalContainer: {
            ".ms-Dialog-title": {
                padding: 5,
                minHeight: '36px'
            },
            ".ms-Dialog-button--close": {
                bottom: '12px',
                left: '12px',
            },
            ".ms-Dialog-main": {
                borderRadius: '8px',
                overflowY: 'hidden',
            },
            ".ms-Dialog-inner": {
                padding: '0px'
            },
            ".ms-Dialog-actions": {
                paddingBottom: '24px',
                paddingRight: '24px',
                paddingLeft: '24px',
                display: 'flex',
                justifyContent: 'space-between',
                width: '100% !important',
                margin: '0',
                paddingTop: '12px',
                '@media (max-height: 550px)': {
                    position:'relative',
                }
            },
            '.ms-Dialog-actionsRight': {
                width: '100% !important',
            },
            ".ms-Dialog-action": {
                width: '100%'
            },
            ".ms-Modal-scrollableContent": {
                overflowY: "auto",
                '@media (max-height: 550px)': {
                    overflowY: 'auto',
                },
            }
        },
        announcementContentContainer: {
            overflow: "hidden",
        },
        useDialogStyles: {
            root: {
                marginBottom: '10px !important',
            },
        },
        bodyDescriptionStyles: {
            padding: '24px',
            paddingBottom: '0px',
            minHeight: '365px',
            overflowY: 'auto',
        },
        stepper: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
            right: '8px',
        },          
        step: {
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: theme.palette.themeLight,
            margin: '0 4px',
        },
        activeStep: {
            width: '16px',
            height: '8px',
            borderRadius: '100px',
            background: theme.palette.themePrimary,
        },
        footerButtonContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        dialogFooter: {
            width: '100%',
            height: '10vh',
            maxHeight: '60px',
            bottom: '0',
            backgroundColor: theme.palette.white,
        },
        knowMoreLink: {
            textDecoration: 'underline',
        },
        descriptionContainer: {
            overflowY: 'auto', 
            '@media (min-height:550px) and (max-height: 756px)': {
                overflowY: 'hidden',
                // height: '15vh',
            },
            '@media (max-height: 550px)': {
                overflowY:'auto',
                height:'auto'
            }
        }
    }
};


